var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:( _obj = {}, _obj['optima-' + _vm.theme] = true, _obj )},[_c(_vm.layout,{tag:"component",attrs:{"optima-theme":_vm.theme}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }